import JEPeripherals from "./peripherals";
export default JEPeripherals;
